const W = 400, CX = 200, CY = 205, R = 165;

const pt = (f, r = R) => {
  const a = Math.PI - f * Math.PI;
  return [CX + r * Math.cos(a), CY - r * Math.sin(a)];
};

export function YearArc({ arc, total, week, year = 1, status, compact = false }) {
  const here = Math.min(1, Math.max(0, (week - 0.5) / total));
  const [hx, hy] = pt(here);
  return (
    <div data-testid="year-arc">
      <div className="relative">
      <svg viewBox={`0 0 ${W} 230`} className="w-full h-auto" role="img" aria-label={`Week ${week} of ${total}`}>
        {Array.from({ length: total }, (_, i) => {
          const [x1, y1] = pt(i / total, R + 14);
          const [x2, y2] = pt(i / total, R + (i % 4 === 0 ? 22 : 18));
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={i < week ? "#2D2926" : "#D6CFC5"} strokeWidth={i % 4 === 0 ? 1.4 : 0.8} />;
        })}
        {arc.map((s) => {
          const f0 = (s.start_week - 1) / total, f1 = (s.start_week - 1 + s.weeks) / total;
          const [x0, y0] = pt(f0 + 0.004), [x1, y1] = pt(f1 - 0.004);
          const [lx, ly] = pt((f0 + f1) / 2, R - 30);
          return (
            <g key={s.key} data-testid={`arc-seg-${s.key}`}>
              <path d={`M ${x0} ${y0} A ${R} ${R} 0 0 1 ${x1} ${y1}`} fill="none" stroke={s.color}
                strokeWidth={s.state === "current" ? 16 : 11} strokeLinecap="round" opacity={s.state === "upcoming" ? 0.28 : 1} />
              <text x={lx} y={ly + 6} textAnchor="middle" fontSize={s.state === "current" ? 22 : 17} fontFamily="Fraunces, Georgia, serif" fontWeight="600"
                fill={s.state === "upcoming" ? "#A8A097" : s.state === "current" ? s.color : "#2D2926"}>{s.letter}</text>
            </g>
          );
        })}
        <circle cx={hx} cy={hy} r="11" fill="#fff" stroke="#2D2926" strokeWidth="2" />
        <circle cx={hx} cy={hy} r="4.5" fill="#2D2926" className={status === "active" ? "animate-pulse" : ""} />
      </svg>
      <div className="absolute inset-x-0 bottom-1 text-center pointer-events-none">
        <div className="eyebrow">Year {year}{status !== "active" ? ` · ${status}` : ""}</div>
        <div className={`font-display tracking-tight ${compact ? "text-3xl" : "text-4xl"}`} data-testid="arc-week">Week {week}</div>
        <div className="text-xs text-stone-600">of {total}{total !== 52 ? " (your year adapts to you)" : ""}</div>
      </div>
      </div>
      <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 mt-3 text-[11px]" data-testid="arc-legend">
        {arc.map((s) => <span key={s.key} className={s.state === "current" ? "font-semibold text-stone-900" : s.state === "done" ? "text-stone-700" : "text-stone-500"}><b style={{ color: s.color }}>{s.letter}</b> {s.name}</span>)}
      </div>
    </div>
  );
}
